import { PageLayout } from '~/components/PageLayout/PageLayout';
import { LoginForm } from './components/login-form';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Logga in" />
      <LoginForm />
    </Fragment>
  );
}
